module.exports = __webpack_public_path__ + "static/sf_1.4af75d04.png";